<script>
	import { openModal, closeModals } from 'utilities';
	import Modal from 'components/modal.vue';
	import VimeoPlayer from 'components/vimeo-player.vue';

	export default {
		components: {
			modal: Modal,
			'vimeo-player': VimeoPlayer
		},
		modelData: ['dismissTeacherGuideModal', 'tgModalHideExpiration'],
		methods: {
			shouldShowModal() {
				if (this.dismissTeacherGuideModal) {
					return;
				}

				const expiration = this.tgModalHideExpiration || 0;
				const expirationPassed = expiration < Date.now();

				if (expirationPassed) {
					openModal('#teacher-guide-modal');
				}
			},
			temporarilyDismiss() {
				closeModals();

				const date = new Date(Date.now());
				date.setDate(date.getDate() + 30);

				this.tgModalHideExpiration = date.getTime();
			},
			permanentlyDismiss() {
				closeModals();

				this.dismissTeacherGuideModal = true;
			}
		},
		mounted() {
			this.shouldShowModal();
		}
	};
</script>
<style lang="scss">
	@import 'mixins/media';

	#teacher-guide-modal {
		.modal-window-wrap {
			max-width: 800px;
		}

		.vimeo-player {
			width: 100%;
			height: auto;
			min-height: 300px;

			@include media(med) {
				min-height: 480px;
			}
		}

		.button-container {
			white-space: nowrap;
			display: grid;
			gap: 1rem;
			justify-content: center;

			@include media(med) {
				grid-template-columns: repeat(2, auto);
			}
		}

		.dismiss {
			@include media(med) {
				grid-column: 1/3;
			}
		}
	}
</style>
<template>
	<modal id="teacher-guide-modal">
		<div slot="header-container">
			<h2>Welcome to the ReadWorks Teacher Guide</h2>
		</div>
		<div slot="content">
			<vimeo-player video-id="896640615"></vimeo-player>
			<div class="button-container margin-top-medium">
				<button
					class="button -outline temp-dismiss"
					@click="temporarilyDismiss">
					Explore the Teacher Guide
				</button>
				<a
					href="/webinars"
					class="button">
					Webinars
				</a>
				<button
					class="button -link -link-muted dismiss font-small"
					@click="permanentlyDismiss">
					Don't show this message again.
				</button>
			</div>
		</div>
	</modal>
</template>
